"use client";

import Link from "next/link";
import { usePathname } from "next/navigation";
import { useTranslation } from "react-i18next";
import { getLocaleFromPath } from "../lib/i18n/utils";

export default function RoomContextualLinks() {
  const { t } = useTranslation();
  const pathname = usePathname();
  const locale = getLocaleFromPath(pathname);

  const links = [
    {
      href: locale === "el" ? "/area" : `/${locale}/area`,
      label: t("Explore Kastoria & Grammos"),
    },
    {
      href: locale === "el" ? "/rooms" : `/${locale}/rooms`,
      label: t("View all rooms"),
    },
    {
      href: locale === "el" ? "/contact" : `/${locale}/contact`,
      label: t("Contact us"),
    },
  ] as const;

  return (
    <div className="mt-8 pt-8 border-t border-ui-card/20">
      <nav
        aria-label={t("Related links")}
        className="flex flex-col items-start gap-2 text-sm leading-6 sm:flex-row sm:flex-wrap sm:gap-y-2 sm:gap-x-8 md:gap-x-10"
      >
        {links.map((link) => (
          <Link
            key={link.href}
            href={link.href}
            className={[
              "inline-block max-w-full py-1",
              "text-ui-card/70 hover:text-ui-card",
              "underline decoration-ui-card/30 hover:decoration-ui-card underline-offset-4",
              "transition-colors",
              "focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ui-card/30 focus-visible:ring-offset-2 focus-visible:ring-offset-ui-background",
            ].join(" ")}
          >
            {link.label}
          </Link>
        ))}
      </nav>
    </div>
  );
}

